<template>
  <!--BOOST LANDING PAGE: Story CD-18 -->
  <div class="flex items-center space-x-4">
    <SkeletonComponent class="h-12 w-12 rounded-full" />
    <div class="space-y-2">
      <SkeletonComponent class="h-4 w-[250px]" />
      <SkeletonComponent class="h-4 w-[200px]" />
    </div>
  </div>
</template>

<script setup lang="ts">
import SkeletonComponent from '../ui/skeleton/SkeletonComponent.vue';
</script>
